export default "__VITE_ASSET__CNjmVj3l__"